import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

// $ = jQuery;

$(document).ready(function () {
  sliderInit();
});

function sliderInit() {
  var carousels = $('.splide');

  for (var i = 0; i < carousels.length; i++) {
    const carousel = $(carousels[i]);
    const carouselPerPage = carousel.attr('data-perPage');

    const splide = new Splide(carousels[i], {
      perPage: carouselPerPage,
      perMove: 1,
      pagination: false,
      gap: '1.5rem',
      breakpoints: {
        992: {
          perPage: 3,
          gap: '1rem',
        },
        640: {
          perPage: 2,
        },
        480: {
          perPage: 1,
          gap: '.5rem',
        },
      }
    });

    splide.mount();
  }
}

